import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.SubmitFeedback = {
  displayName: 'SubmitFeedback',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    onStepProgression()
  },

  buttonLayout: function() {
    return 'none'
  },

  component: React.createClass({
    componentDidMount: function() {
      this.createJobClosure()
    },

    createJobClosure: function() {
      let surveyData = Job.Data.closureSurvey

      $.ajax({
        url: `/jobs/job/${surveyData.job.id}/closure`,
        type: 'PUT',
        dataType: 'json',
        data: {
          survey: {
            closure: {
              outcome: surveyData.outcome,
              provider_account_id: surveyData.providerAccountId,
              value: surveyData.value
            },
            closure_history: {
              trigger: 'job_modal',
              medium: 'web'
            },
            feedback: {
              rating: surveyData.rating,
              comments: surveyData.comments
            },
            feedback_reasons: surveyData.selectedReasons,
            from_fast_feedback: false
          }
        }
      }).done((data) => {

        if (surveyData.rating) {
          JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.PostJobAgain)
        } else {
          this.redirectToJobPage()
        }
      }).fail((jqXHR, textStatus) => {
        document.location.href = '/500'
      })
    },

    redirectToJobPage: function(){
      let jobID = Job.Data.id
      let url = ''
      let message = JSON.stringify({message_type: 'jobs_wizard', message: 'JOB_POSTING_COMPLETED', payload: jobID})

      if (JobWizardMobile.MessageChannel.sendMessage(message) == true) {
        return;
      }

      switch (Job.Data.referrer.cta) {
        case 'profile': {
          url = `/jobs/${jobID}/profilejob?successful_job=true`
        }
        case 'business_directory_card': {
          url = `/jobs/${jobID}/bcardjob?successful_job=true`
        }
        default: {
          url = `/jobs/${jobID}/posted?successful_job=true`
        }
      }

      document.location.href = url 
    },

    render: function() {
      return (
        <div className="modal-body job-closure-form-body">
          <h3>Saving feedback details...
            <div className="spinner-icon text-center ml15" />
          </h3>
        </div>
      )
    }
  })
}
